import { render } from "./Transaction.vue?vue&type=template&id=2688fb3c&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=2688fb3c&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2688fb3c"]])

export default __exports__